import { useEffect,  React, useState } from "react";
import { TextInput, Loading, Content, Button, Grid, Column, Stack, InlineNotification } from '@carbon/react';
import { useLocation } from "react-router-dom";


const Registro = () => {
    let  loc  = useLocation();

    /**
    * Obtenemos parametros de url
    * @Param rfc: RFC encontrado
    */
    const search = loc.search;
    const params = new URLSearchParams(search); 
    var rfc = params.get('rfc'); 
    const [loading, setLoading] = useState(false);
    const [msgRegistro, setMsgRegistro] = useState([]);
  
    var RE = {
        ColorHrLine: ({ color }) => (<hr style={{ color: color, backgroundColor: color, height: 2 }} />),
        spanHeight: ({ height }) => (<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: height }} />),
        aHome(){
            window.location.href = "/#/Login";
        },
        hideMesgRegistro: function() {
            setMsgRegistro({ "showMsg": 0 });
        }
    }

    useEffect(() => {
        
    }, []);

 
    return (
        <>
        <Content className="espacio">
            <Loading className={'some-class'} active={loading} withOverlay={true} />
            <Grid>
                <Column lg={12} md={8} sm={4}>
                    <h3 style={{ margin: '15px 0 20px' }}>Registro.</h3>
                    < RE.ColorHrLine color={"black"} />
                </Column>
                <Column lg={4} md={8} sm={4}> </Column>
                <Column lg={4} md={8} sm={4}> </Column>
            </Grid>
            <RE.spanHeight height="8vh" />
            <form >
                <Stack gap={6}>
                    <Grid>
                        <Column lg={4} md={8} sm={4}>
                            <TextInput id="txtRFC" type="text"
                                readOnly={true}
                                value={rfc}
                                labelText="RFC"
                            />
                        </Column>
                        <Column lg={4} md={8} sm={4}>
                            <TextInput id="txtNombre" type="text"
                                readOnly={true}
                                labelText="Nombre"
                             />
                        </Column>
                        <Column lg={4} md={8} sm={4}>
                            <TextInput id="txtCURP" type="text"
                                readOnly={true}
                                labelText="CURP"
                            />
                        </Column>
                        <Column lg={4} md={4} sm={4}>
                            <TextInput id="txtNumEmp" type="text"
                                readOnly={true}
                                labelText="Número de empleado"
                            />
                        </Column>
                    </Grid>
                    <Grid>

                        <Column lg={4} md={4} sm={4}>
                            <TextInput id="txtCorreo" type="text" 
                                labelText="Correo"
                                placeholder="Ingresa un correo"
                            />
                        </Column>
                        <Column lg={4} md={4} sm={4}>
                            <TextInput id="txtPassword" type="text"
                                labelText="Password"
                                placeholder="Ingresa un p"
                            />
                        </Column> 
                                            
                        <Column lg={4} md={4} sm={4} > 
                            <RE.spanHeight height="3vh" />
                            <Button id="btnRegEmp" kind="primary" type="submit">Registrar</Button>
                        </Column>
                    </Grid>
                    <Grid>
                        <Column lg={16} md={16} sm={16} >
                            <br />
                            {(msgRegistro.showMsg === 1) &&
                                <InlineNotification kind={msgRegistro.kind}
                                    title={msgRegistro.mensaje}
                                    lowContrast={true}
                                    onClick={RE.hideMesgRegistro} />
                            }
                        </Column>
                    </Grid>
                </Stack>
            </form>
        </Content>
    </>
    );
};

export default Registro;